export const modules = ['@mantine/core', '@mantine/hooks']

export const isExternalMantine = module => {
    return modules.includes(module)
}

export const isExternalMantineFn = nextHandler => {
    return ({ context, request }, callback) => {
        if (isExternalMantine(request)) return callback(null, `commonjs ${request}`)

        return nextHandler?.({ context, request }, callback)
    }
}
